import React from "react";
import { useTranslation } from "react-i18next";


const VendorSection = () => {
  const { t, i18n } = useTranslation("products"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div className="relative mx-auto px-[30px] max-w-[1220px] w-full flex flex-col items-center mt-[53px] mb-[70.45px]">
      {/* Container for "Vendors" Text, Horizontal Line, and Button */}
      <div className="w-full flex items-center ">
        {/* Left Side: "Vendors" Text */}
        <div className="w-1/3 text-left">
          <h2 className={`title-medium-3 text-[#FFFFFF] mb-2 ${isRussian ? 'lang-ru-vendor-offering' : ''} `}>{t("vendors_title")}</h2>
        </div>

        {/* Middle: Horizontal Line */}
        <div className="w-full mx-4 border-t border-[#05897E] horizontal-line"></div>

        {/* Right Side: "Explore Products" Button */}
        <div className="w-1/3 text-right btn-adjustment">
          <button className="title-small-13 bg-[#05897E] py-2 px-3.5 rounded-[6px] margin-bottom-adjustment">
            {t("explore_products")}
          </button>
        </div>
      </div>

      {/* Image Container Below the Text Section */}
      <div className="relative w-full h-[581px] rounded-xl overflow-hidden shadow-lg group">
        {/* Background Image with Custom Clip-Path */}
        <img
          src="/assets/supporting.svg"
          alt="Safety Work Environment"
          className="w-full h-full object-cover top-left-rounded-clip group-hover:opacity-60 transition-opacity duration-300 space-adjustment"
        />

        {/* Text in the Top-Left Corner */}
        <div className={`absolute top-1 left-1 title-medium-3 text-white group-hover:opacity-60 transition-opacity duration-300 ${isRussian ? 'lang-ru-vendor-offering' : ''}`}>
          {t("offerings_title")}
        </div>

        {/* Text and Button revealed on hover */}
        <div className="absolute bottom-0 left-0 w-full h-[200px] bg-gradient-to-t from-black to-transparent group-hover:h-[200px] transition-all duration-300">
          <div className="flex justify-between items-center h-full px-5">
            {/* Left Side: Text */}
            <div className="flex flex-col items-start text-white space-y-4 opacity-0 group-hover:opacity-100 group-hover:translate-y-[-16px] transition-all duration-300 space-adjustment">
              <div className="max-w-[424px]">
                {/* Title */}
                <h3 className={`body-xl-3 text-color-6 tracking-tight mb-3 ${isRussian ? 'lang-ru-vendor-title' : ''}`}>
                  {t("proximity_detection_collision_avoidance")}
                </h3>
                {/* Description */}
                <p className={`body-large-7 text-color-6 tracking-[1px] ${isRussian ? 'lang-ru-vendor-desc' : ''}`}>
                  {t("proximity_detection_collision_avoidance_description")}
                </p>
              </div>
            </div>

            {/* Right Side: Button */}
            <div className="flex items-center opacity-0 group-hover:opacity-100 group-hover:translate-y-[-16px] transition-all duration-300 mt-32 space-adjustment">
              <button>
                <img src="/assets/link.svg" alt="Link Icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorSection;
